import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { getFontSizeVariables } from '@/utils';

import { getBackgroundColorStyle } from '../../../utils/background';
import { computeColor } from '../../../utils/colors';

import MagnifyingGlass from '../../../icon/MagnifyingGlass';
import * as styles from '../../Navbar.css';
import { NAVBAR_MENU_ITEM_BORDER_DEFAULTS, NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2 } from '../NavbarMenuItem.constants';
import type { NavbarMenuItemV2ElementProps } from '../NavbarMenuItem.type';

export function NavbarMenuItemSearchV2(props: NavbarMenuItemV2ElementProps) {
  const { element, className, children, onClick, attributes } = props;
  if (element.attrs?.type !== 'search') {
    return null;
  }
  const {
    customAttributes,
    padding,
    background,
    borderRadius,
    color,
    fontFamily,
    letterSpacing,
    borderColor,
    borderWidth,
    borderStyle,
    hoverBorderColor,
    hoverBorderStyle,
    hoverBorderWidth,
    hoverBorderRadius,
    hoverTextColor,
    hoverBackgroundColor,
    mobileColor,
    mobilePadding,
    mobileFontSize,
    fontSize,
    mobileBackground,
  } = element.attrs || {};

  return (
    <div className={styles.navbarItemLinkContainerV2} {...attributes}>
      <div
        {...props}
        onClick={(e) => {
          onClick?.(e);
        }}
        role="presentation"
        {...customAttributes}
        className={classNames(styles.navbarItemSearchV2, className, customAttributes?.className)}
        style={
          {
            '--padding': padding ?? NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.padding,
            '--border-radius': borderRadius ?? NAVBAR_MENU_ITEM_BORDER_DEFAULTS.borderRadius,
            '--background-color': getBackgroundColorStyle(background ?? NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.background)
              .background,
            '--text-color': computeColor(color ?? NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.color),
            '--font-family': fontFamily ?? NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.fontFamily,
            '--letter-spacing': letterSpacing ?? NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.letterSpacing,
            '--hover-border-radius': hoverBorderRadius || borderRadius || NAVBAR_MENU_ITEM_BORDER_DEFAULTS.borderRadius,
            '--hover-text-color': hoverTextColor || color || NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.color,
            '--hover-background-color':
              hoverBackgroundColor || background || NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.background,
            '--hover-border-color': hoverBorderColor || borderColor || NAVBAR_MENU_ITEM_BORDER_DEFAULTS.borderColor,
            '--hover-border-style': hoverBorderStyle || borderStyle || NAVBAR_MENU_ITEM_BORDER_DEFAULTS.borderStyle,
            '--hover-border-width': hoverBorderWidth || borderWidth || NAVBAR_MENU_ITEM_BORDER_DEFAULTS.borderWidth,
            '--mobile-text-color': computeColor(mobileColor || color || NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.color),
            '--mobile-padding': mobilePadding || padding || NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.padding,
            ...getFontSizeVariables(fontSize, mobileFontSize),
            '--mobile-background-color':
              mobileBackground || background || NAVBAR_MENU_ITEM_SEARCH_DEFAULTS_V2.background,
            gap: '4px',
          } as CSSProperties
        }
      >
        <MagnifyingGlass size={16} weight="bold" />
        <span className={styles.navbarItemSearchTextV2}>Search</span>
      </div>
      {children}
    </div>
  );
}
